import * as yup from "yup";

export const tournamentFormSchema = yup.object().shape({
    parent: yup
        .number()
        .nullable()
        .optional()
        .transform(value => (Number.isNaN(value) ? null : value)),
    name: yup
        .string()
        .when("parent", {
            is: (val: any) => !val,
            then: schema => schema.required("Please set the tournament name"),
            otherwise: schema => schema.optional(),
        })
        .nullable(),
    description: yup.string().optional().nullable(),
    active: yup.boolean().required(),
    showOnUmphub: yup.boolean().when("parent", {
        is: (val: any) => !val,
        then: schema =>
            schema.required(
                "Should the games be shown on UmpHub for registration?",
            ),
        otherwise: schema => schema.optional(),
    }),
    showToPublic: yup.boolean().when("parent", {
        is: (val: any) => !val,
        then: schema =>
            schema.required(
                "Should the standings/schedule be available to the public?",
            ),
        otherwise: schema => schema.optional(),
    }),
    poolGames: yup
        .number()
        .when("parent", {
            is: (val: any) => !val,
            then: schema =>
                schema.required(
                    "Please specify the number of pool play games per team",
                ),
            otherwise: schema => schema.optional(),
        })
        .transform(value => (Number.isNaN(value) ? null : value)),
    logo: yup.mixed<File[]>(),
    photos: yup.mixed<File[]>(),
    location: yup
        .object()
        .shape({
            value: yup.number().required(),
            label: yup
                .string()
                .required("Please select the tournament location"),
        })
        .when("parent", {
            is: (val: any) => !val,
            then: schema =>
                schema.required("Please select the tournament location"),
            otherwise: schema => schema.optional(),
        })
        .default(undefined),
    director: yup
        .array(
            yup.object().shape({
                value: yup.number(),
                label: yup.string(),
            }),
        )
        .optional()
        .default(undefined),
    ageLevels: yup
        .array(
            yup.object().shape({
                tournamentId: yup.number().optional(),
                ageLevel: yup
                    .object()
                    .shape({
                        value: yup.number().required(),
                        label: yup
                            .string()
                            .required("Please select the tournament age level"),
                    })
                    .required(),
                maxTeams: yup
                    .number()
                    .required()
                    .moreThan(0, "Please specify the max number of teams"),
                cost: yup
                    .number()
                    .required()
                    .moreThan(0, "Please specify the cost for this age level"),
                bracket: yup
                    .object()
                    .shape({
                        value: yup.number(),
                        label: yup.string(),
                    })
                    .optional()
                    .default(undefined),
            }),
        )
        .optional(),
    designation: yup
        .object()
        .shape({
            value: yup.number().required(),
            label: yup.string().required(),
        })
        .when("parent", {
            is: (val: any) => !val,
            then: schema =>
                schema.required("Please set the tournament competition level"),
            otherwise: schema => schema.optional(),
        })
        .default(undefined),
    teams: yup
        .array(
            yup.object().shape({
                value: yup.number().required(),
                label: yup.string().required(),
            }),
        )
        .optional()
        .default([]),
    startDate: yup.date().when("parent", {
        is: (val: any) => !val,
        then: schema => schema.required("Please set the tournament start date"),
        otherwise: schema => schema.optional(),
    }),
    endDate: yup.date().when("parent", {
        is: (val: any) => !val,
        then: schema => schema.required("Please set the tournament end date"),
        otherwise: schema => schema.optional(),
    }),
    hotelLink: yup.string().optional(),
    schedulingData: yup
        .object()
        .shape({
            noFriday: yup
                .array(
                    yup.object().shape({
                        value: yup.number(),
                        label: yup.string(),
                    }),
                )
                .optional()
                .default([]),
            homeLeagues: yup
                .array(
                    yup
                        .object()
                        .shape({
                            value: yup.number(),
                            label: yup.string(),
                        })
                        .nullable(),
                )
                .optional()
                .default([]),
        })
        .optional(),
    homeLeagues: yup
        .array(
            yup.object().shape({
                league: yup.string().optional(),
            }),
        )
        .optional(),
    teamCities: yup
        .array(
            yup.object().shape({
                city: yup.string().optional(),
            }),
        )
        .optional(),
});
